module.exports = __webpack_public_path__ + "static/media/button.327e109f.png";